import { Container, Grid } from "@mui/material";
import Link from "next/link";
import { JobGuidBox } from "styles/jss/JobSeekers.styles";
import { AnnoncementIcon, BriefCaseFullIcon, PaperIcon } from "../../IconsSvg";
import { useTranslation } from "next-i18next";
import { useRouter } from "next/router";

export default function JobSeekGuidBox() {
  const { t } = useTranslation(["common"]);
  const { locale } = useRouter();

  const BOX = [
    {
      icon: <BriefCaseFullIcon />,
      title: t("jobSeekers.box1.title"),
      subtitle: t("jobSeekers.box1.subtitle"),
      url: "/employees/job-positions",
    },
    ...(locale === "en"
      ? [
          {
            icon: <AnnoncementIcon />,
            title: t("jobSeekers.box3.title"),
            subtitle: t("jobSeekers.box3.subtitle"),
            url: "/employees/international-employment-form",
          },
        ]
      : [
          {
            icon: <PaperIcon />,
            title: t("jobSeekers.box2.title"),
            subtitle: t("jobSeekers.box2.subtitle"),
            url: "/employees/employment-form",
          },
        ]),
  ];

  return (
    <Container sx={{ my: "80px" }}>
      <Grid
        container
        justifyContent={"center"}
        columnSpacing={3}
        rowSpacing={3}
      >
        {BOX.map(({ title, subtitle, icon, url }, index) => (
          <Grid item key={index}>
            <Link href={url}>
              <a>
                <JobGuidBox>
                  <i className={"icon"}>{icon}</i>
                  <p className={"title"}>{title}</p>
                  <p className={"subTitle"}>{subtitle}</p>
                </JobGuidBox>
              </a>
            </Link>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
}
